/**
 * External dependencies
 */
export default class UserFtp {
    constructor(cscom) {
        if (!(this instanceof UserFtp)) {
            return new UserFtp(cscom);
        }
        this.cscom = cscom;
    }

    getFtpDetails() {
        return this.cscom.req.get('/user-site-api/user-ftp-details');
    }

    testFtpConnection() {
        return this.cscom.req.get('/user-site-api/test-user-ftp');
    }

}
